require 'angular'
app = angular.module('workflow.app')

app.directive('comment', require('./Comment'))
app.directive('commentsList', require('./CommentsList'))
